import React from 'react';
import type { Room } from '../types';

interface RoomFloatingActionsProps {
  selectedRoom: Room | null;
  isVisible: boolean;
  onRename: (room: Room) => void;
  onClose: () => void;
}

const RoomFloatingActions: React.FC<RoomFloatingActionsProps> = ({
  selectedRoom,
  isVisible,
  onRename,
  onClose,
}) => {
  if (!isVisible || !selectedRoom) {
    return null;
  }

  const handleRename = () => {
    onRename(selectedRoom);
    onClose();
  };

  const roomLabel = selectedRoom.name || `Room ${selectedRoom.id}`;

  return (
    <div className="fixed bottom-20 right-4 z-[1000] flex flex-col items-end gap-2 max-w-[250px]">
      {/* Room info card */}
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 flex-shrink-0">
        <div className="flex items-center justify-between gap-2">
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-gray-900 truncate">
              {roomLabel}
            </h3>
            <p className="text-xs text-gray-500">
              {selectedRoom.area?.toFixed(2) || '0'} sq ft
            </p>
          </div>
          <button
            onClick={onClose}
            className="flex-shrink-0 p-1 text-gray-400 hover:text-gray-600 touch-manipulation"
            aria-label="Close"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex gap-2">
        <button
          onClick={handleRename}
          className="bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white rounded-full p-3 shadow-lg transition-colors touch-manipulation flex items-center gap-2"
          aria-label="Rename room"
        >
          <svg 
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" 
            />
          </svg>
          <span className="text-sm font-medium">Rename</span>
        </button>
      </div>
    </div>
  );
};

export default RoomFloatingActions; 